import {Lang} from '@context/CompetitionImamrezaContext';

export function getSafeLangImage(images: Record<Lang, string>, lang: string | undefined) {
	if (!lang) return '';
	return images[lang as Lang] || '';
}

export function isValidPhoneNumber(phone: string): boolean {
	// Remove any non-digit characters just in case
	const cleaned = phone.replace(/\D/g, "");
	
	// Match Iranian mobile format: starts with 09 and has 11 digits
	const regex = /^09\d{9}$/;
	
	return regex.test(cleaned);
}
